'use strict'

/**
 * 主タスク（詳細期間）と、年次・四半期で G0006 を参照するときに必要な月次タスクのマッピングをまとめて用意する層。 404
 * は「そのキーでは未登録」とみなし空配列に落とす。それ以外は上位でユーザー向けメッセージにできるよう再スローする。
 */

import { fetchGenericMappingList } from './services'
import { resolveMonthlyTaskKeyForMatrixSelection } from './matrixMonthlyTaskResolve'

/**
 * Get_generic_mapping_list を呼び、404 は空配列に正規化する
 *
 * @param {string} corporationNumber
 * @param {number} dataCreateTaskKey
 * @returns {Promise<import('./types').GenericMappingListResponse>}
 */
async function fetchGenericMappingListOrEmpty(corporationNumber, dataCreateTaskKey) {
  try {
    const res = await fetchGenericMappingList(corporationNumber, dataCreateTaskKey)
    return Array.isArray(res) ? res : []
  } catch (err) {
    if (err?.response?.status === 404 || err?.response?.statusCode === 404) {
      return []
    }
    throw err
  }
}

/**
 * 主キー（詳細期間）と必要なら月次キーでマッピングを並列取得する
 *
 * @param {string} corporationNumber
 * @param {unknown[]} taskListFull
 * @param {string} periodKind
 * @param {number | null} detailPeriodKey
 * @param {string | null | undefined} accPeriod
 * @returns {Promise<{
 *   mappingList: import('./types').GenericMappingListResponse
 *   mappingListMonthly: import('./types').GenericMappingListResponse
 * }>}
 */
export async function loadMatrixMappingPair(corporationNumber, taskListFull, periodKind, detailPeriodKey, accPeriod) {
  if (!corporationNumber || detailPeriodKey == null) {
    return { mappingList: [], mappingListMonthly: [] }
  }

  const selectedTask = Array.isArray(taskListFull) && taskListFull.find((t) => (t.key ?? t.Key) === detailPeriodKey)

  const monthlyKey = resolveMonthlyTaskKeyForMatrixSelection(
    taskListFull || [],
    selectedTask ?? null,
    periodKind,
    accPeriod
  )

  const primaryPromise = fetchGenericMappingListOrEmpty(corporationNumber, detailPeriodKey)

  if (monthlyKey == null) {
    const mappingList = await primaryPromise
    return { mappingList, mappingListMonthly: [] }
  }

  if (monthlyKey === detailPeriodKey) {
    const mappingList = await primaryPromise
    return { mappingList, mappingListMonthly: mappingList }
  }

  const [mappingList, mappingListMonthly] = await Promise.all([
    primaryPromise,
    fetchGenericMappingListOrEmpty(corporationNumber, monthlyKey)
  ])
  return { mappingList, mappingListMonthly }
}
